import * as React from 'react';
import { useMutation } from 'react-query';
import {
	Alert, AlertTitle,
	Card, CardContent,
} from '@mui/material';
import {
	Form, RecordContextProvider, Title, TextInput, SaveButton,
	regex, useDataProvider, useNotify,
} from 'react-admin';
import { requestVerificationCode } from '../model/cloud';

const validatePhoneNumber = regex(/^\+?(7|8)\d{10}$/, 'неверный формат номера');

const VerificationCode = () => {
	const dataProvider = useDataProvider();
	const notify = useNotify();
	const { mutateAsync, data, isError } = useMutation((values) => {
		return requestVerificationCode(dataProvider, values.phone);
	});
	const handleSubmit = (values) => {
		mutateAsync(values)
			.then(() => { notify('Код получен', { type: 'success' }); })
			.catch((error) => { notify(error.toString(), { type: 'error' }); });
	};

	return (
		<RecordContextProvider record={{}}>
			<Card>
				<Title title="Код проверки" />
				<CardContent>
					<Form onSubmit={handleSubmit}>
						<div>
							<div>
								<TextInput label="Номер телефона" source="phone" validate={validatePhoneNumber} />
							</div>
							<div>
								<SaveButton label="Получить код" />
							</div>
							{
								data && !isError ? (
									<Alert severity="success" style={{ marginBlockStart: '10px' }}>
										<AlertTitle>Код получен</AlertTitle>
										Новый код —
										<strong>{data.data.newCode}</strong>
									</Alert>
								)	:	null
							}
						</div>
					</Form>
				</CardContent>
			</Card>
		</RecordContextProvider>
	);
};

export default VerificationCode;
